export const VENDOR_CREDITS_ROUTES = {
    CREATE: "/{service_company_slug}/vendor-credits/create/",
    LIST: "/{service_company_slug}/vendor-credits/",
    COUNT: "/{service_company_slug}/api/vendor-credits/count/",
    LIGHTWEIGHT_LIST: "/{service_company_slug}/api/vendor-credits/lightweight/",
    UPDATE: "/{service_company_slug}/vendor-credits/{id}/update/",
    DETAILS: "/{service_company_slug}/vendor-credits/{id}/",
}
